module.exports = __webpack_public_path__ + "static/media/login-bg-desktop.3201616c.jpg";